import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import Typography from "../../components/Typography";
import useContainerGroup from "../../hooks/useContainerGroup";
import GroupService from "../../services/identity/group.service";
import CardGroupInfo from "../../components/Group/cardGroupInfo";
import CardListUserByGroup from "../../components/Group/cardListUserByGroup";

import { MainComponent } from "../main";
import { ActionRequest, GroupType, Mode, Status } from "../../constants/enums";
import { IOrgUserProfile, IUserRole } from "../../hooks/useContainerOrganization";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { ICodename, ILableOrganization, IMultiLanguageContent, IPropDetailContainer } from "../../commons/interfaces";



export interface IGroupUserResponses {
    id: string;
    default: number;
    manager: number;
    groupId: string;
    groupName: any;
    userId: string;
    userTitle: string;
    userTitleName: string;
    userRoles?: IUserRole[];
    userProfile?: IOrgUserProfile;

    status: number;
    endTime: string;
    startTime: string;
    createTime: string;
    createUser: string;
    updateTime: string;
    updateUser: string;
}

export interface IDataDetailGroup {
    id?: string;
    type?: number;
    parentGroupId?: string;
    name?: IMultiLanguageContent;
    description?: IMultiLanguageContent;

    status?: number;
}

type IProps = IPropDetailContainer & ILableOrganization & {
    title?: string;
    newDomain?: string;

    hidenStatus?: boolean;
    hidenActionUpdate?: boolean;
    hidenInputSelectGroupParent?: boolean;
    requiredInputSelectGroupParent?: boolean;

    hidenActionCreateMember?: boolean,
    hidenActionUpdateMember?: boolean,
    hidenActionDeleteMember?: boolean,
    hidenActionInvitationMember?: boolean,

    modalCreateMember?: (props: {
        groupId?: string;
        organizationId: string;
        onCallBack?: () => void
    }) => JSX.Element;
    modalInvitationMember?: (props: {
        groupId?: string;
        organizationId: string;
        onCallBack?: () => void
    }) => JSX.Element;
}

const GroupEditContainer = ({
    title,
    newDomain,
    lableStaff,
    lableGroup,

    mode,
    idDetail,
    hidenStatus,
    hidenActionUpdate,
    hidenInputSelectGroupParent,
    requiredInputSelectGroupParent,

    modalCreateMember,
    hidenActionCreateMember,
    modalInvitationMember,
    hidenActionInvitationMember,
    hidenActionDeleteMember,
    hidenActionUpdateMember,

    onGoBack,
    onChangeMode,
}: IProps) => {
    const strings = useStrings();

    const { checkGeneByGroup, getAllDataGroup } = useContainerGroup();

    const {
        clientId, language, userInfo,
        onError, onShowLoading, onHideLoading
    } = useCommonComponentContext();

    const [listParentGroup, setListParentGroup] = useState<ICodename[]>([]);
    const [listUserIdSelected, setListUserIdSelected] = useState<string[]>([]);
    const [dataDetailGroup, setDataDetailGroup] = useState<IDataDetailGroup>({});
    const [idGroupDefaultCompany, setIdGroupDefaultCompany] = useState<string | undefined>(undefined);
    const [dataRowsUserGroup, setDataRowsUserGroup] = useState<(IGroupUserResponses & { action: number })[]>([]);

    const newLableStaff = useMemo(() => (
        (lableStaff || strings.Common.STAFF).toLowerCase()
    ), [lableStaff, strings]);

    const newLableGroup = useMemo(() => (
        (lableGroup || strings.Common.GROUP).toLowerCase()
    ), [lableGroup, strings]);

    useEffect(() => {
        if (hidenActionUpdate) {
            onChangeMode(Mode.View);
        }
    }, [hidenActionUpdate]);

    useEffect(() => {
        (async () => {
            try {
                onShowLoading();

                let newParentGroup: ICodename[] = [];
                let idGroupDefault: string | undefined = undefined;

                if (!hidenInputSelectGroupParent) {
                    const resultGetAllGroup = await getAllDataGroup({
                        clientId: clientId,
                        includeCompany: true,
                        listStatus: [Status.Active],
                        organizationId: userInfo?.userProfile?.organizationId,
                    });

                    [...(resultGetAllGroup || [])].forEach((item) => {
                        if (Number(item.detail?.type) === GroupType.Company) {
                            idGroupDefault = item.code as string;
                            setIdGroupDefaultCompany(idGroupDefault);
                        } else {
                            const checkGeneItem = checkGeneByGroup({
                                gene: item.detail?.gene,
                                listGroupSlice: userInfo?.listGroup,
                                roleType: userInfo?.userProfile?.roleType,
                                organizationId: userInfo?.userProfile?.organizationId,
                            });

                            if (checkGeneItem && (idDetail !== item.code)) {
                                const newName = Helpers.renderValueByLanguage({ data: item.name, currentLanguage: language });
                                newParentGroup.push({
                                    ...item,
                                    name: newName,
                                });
                            }
                        }
                    });

                    setListParentGroup(newParentGroup);
                }

                if (!Helpers.isNullOrEmpty(idDetail)) {
                    await getDetail(idDetail, idGroupDefault);
                }
            } catch (error) {

            } finally {
                onHideLoading();
            }
        })()
    }, [idDetail, userInfo?.userProfile?.organizationId]);

    const getDetail = async (id: string, idGroupDefault?: string) => {
        try {
            onShowLoading();

            const resultDetail = await GroupService.getDetail({ id, clientId });

            const parentGroupID = (resultDetail.parentGroup === idGroupDefault) ? undefined : resultDetail.parentGroup;

            const newDataDetail: IDataDetailGroup = {
                id: resultDetail.id,
                type: resultDetail.type,
                name: resultDetail.name,
                status: resultDetail.status,
                parentGroupId: parentGroupID,
                description: resultDetail.description,
            };

            const rowsTemp: any[] = [];
            const dataIds: string[] = [];

            [...resultDetail.groupUserResponses || []].forEach((item) => {
                dataIds.push(item.userId);
                rowsTemp.push({ ...item, action: ActionRequest.Update });
            });

            setDataRowsUserGroup(rowsTemp);
            setListUserIdSelected(dataIds);
            setDataDetailGroup(newDataDetail);

        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    return (
        <MainComponent>
            <Grid container spacing={3}>
                {/* Buton Action */}
                <Grid item xs={12}>
                    <Box sx={{
                        gap: 1,
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: !Helpers.isNullOrEmpty(title) ? "space-between" : "end",
                    }}>
                        {
                            !Helpers.isNullOrEmpty(title) &&
                            <Typography variant="h5">{title}</Typography>
                        }
                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "flex-end",
                        }}>
                            <Button color="secondary" onClick={() => { onGoBack(); }}>
                                {strings.Common.GO_BACK}
                            </Button>
                            {
                                !hidenActionUpdate &&
                                (mode === Mode.View) &&
                                !Helpers.isNullOrEmpty(dataDetailGroup?.id) &&
                                <Button onClick={() => { onChangeMode(Mode.Update); }}>
                                    {strings.Common.EDIT}
                                </Button>
                            }
                        </Box>
                    </Box>
                </Grid>

                {/* Basic Group */}
                <Grid item xs={12}>
                    <CardGroupInfo
                        mode={mode}
                        key={"CardGroupInfo"}
                        hidenStatus={hidenStatus}
                        newLableGroup={newLableGroup}
                        listParentGroup={listParentGroup}
                        dataRowsUserGroup={dataRowsUserGroup}
                        dataDetailGroupBackup={dataDetailGroup}
                        idGroupDefaultCompany={idGroupDefaultCompany}

                        hidenInputSelectGroupParent={hidenInputSelectGroupParent}
                        requiredInputSelectGroupParent={requiredInputSelectGroupParent}
                    />
                </Grid>

                {/* List User By Group */}
                {!Helpers.isNullOrEmpty(dataDetailGroup?.id) && (
                    <Grid item xs={12}>
                        <CardListUserByGroup
                            key={"CardListUserByGroup"}

                            mode={mode}
                            newDomain={newDomain}
                            newLableGroup={newLableGroup}
                            newLableStaff={newLableStaff}
                            dataDetailGroup={dataDetailGroup}
                            dataRowsUserGroup={dataRowsUserGroup}
                            listUserIdSelected={listUserIdSelected}

                            modalCreateMember={modalCreateMember}
                            modalInvitationMember={modalInvitationMember}
                            hidenActionCreateMember={hidenActionCreateMember}
                            hidenActionUpdateMember={hidenActionUpdateMember}
                            hidenActionDeleteMember={hidenActionDeleteMember}
                            hidenActionInvitationMember={hidenActionInvitationMember}

                            onCallBack={(newData) => {
                                if (newData) {
                                    setDataRowsUserGroup(newData.rows);
                                    setListUserIdSelected(newData.userId);
                                } else {
                                    getDetail(dataDetailGroup?.id, dataDetailGroup?.parentGroupId);
                                }
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </MainComponent>
    );
};

export default GroupEditContainer;